import {
    Checkbox,
    FormControlLabel,
    Typography,
    MenuItem,
    Divider,
    ListSubheader,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { CustomizedColumnInWatchList } from '../../reducer/user.reducer';
import { selectCustomizedColumns, selectUserPreferences } from '../../selectors/user';
import { darkBg, white } from '../../assets/colors';
import { updateUserPreferences } from '../../services/apis/user';
import { useCallback } from 'react';
const columnLabels: { [key: string]: keyof CustomizedColumnInWatchList } = {
    Last: 'last',
    Change: 'change',
    'Change%': 'changePercentage',
    Volume: 'volume',
};

export default function WatchListCustomizeColumns() {
    const customizedColumns = useSelector(selectCustomizedColumns);
    const userPreferences = useSelector(selectUserPreferences)

    const handleToggle = useCallback((key: keyof CustomizedColumnInWatchList) => {
        const updatedWatchlistPrefs = {
            ...userPreferences.watchlist,
            customizedColumn: {
                ...customizedColumns,
                [key]: !customizedColumns[key],
            }
        }
        updateUserPreferences({
            body: {
                watchlist: updatedWatchlistPrefs
            }
        })
    }, [customizedColumns, userPreferences])

    return (
        <>
            <Divider />
            <ListSubheader
                sx={{
                    lineHeight: '24px',
                    backgroundColor: 'unset',
                    fontSize: 11,
                    opacity: 0.5,
                    borderTop: 1,
                    borderColor: (theme) => theme.palette.mode === 'dark' ? darkBg : white,
                    paddingLeft: "12px",
                    mt: 0.5
                }}
                key="CUSTOMIE COLUMNS"
            >
                CUSTOMIE COLUMNS
            </ListSubheader>
            {Object.entries(columnLabels).map(([label, key]) => (
                <MenuItem
                    key={label}
                    dense
                    disableGutters
                    onClick={() => handleToggle(key)}
                >
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={customizedColumns[key]}
                                onChange={() => handleToggle(key)}
                                size="small"
                                onClick={(e) => e.stopPropagation()}
                            />
                        }
                        label={<Typography variant="body2"
                            sx={{ opacity: 0.9 }}>{label}</Typography>}
                        sx={{ ml: 1 }}
                    />
                </MenuItem>
            ))}
            <Divider />
            <ListSubheader
                sx={{
                    lineHeight: '20px',
                    backgroundColor: 'unset',
                    fontSize: 11,
                    opacity: 0.5,
                    borderTop: 1,
                    borderColor: (theme) => theme.palette.mode === 'dark' ? darkBg : white,
                    paddingLeft: "12px"
                }}
                key="SYMBOL DISPLAY"
            >
                SYMBOL DISPLAY
            </ListSubheader>
            <MenuItem dense disableGutters>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={userPreferences?.watchlist.customizedColumn?.showLogo ?? false}
                            onChange={(e) => {
                                updateUserPreferences({
                                    body: {
                                        watchlist: {
                                            ...userPreferences.watchlist,
                                            customizedColumn: {
                                                ...userPreferences.watchlist.customizedColumn,
                                                showLogo: e.target.checked
                                            }
                                        }
                                    }
                                })
                            }}
                            size="small"
                            onClick={(e) => e.stopPropagation()}
                        />
                    }
                    label={
                        <Typography variant="body2" sx={{ opacity: 0.9 }}>
                            Logo
                        </Typography>
                    }
                    sx={{ ml: 1 }}
                />
            </MenuItem>

        </>
    );
}
